export enum TransformTypes {
  TRANSLATE = 'translate',
  ROTATE = 'rotate',
  SCALE = 'scale',
}

export enum LineStyle {
  Solid = 'solid',
  Dashed = 'dashed',
}
